// eslint-disable-next-line no-restricted-syntax
enum BuyingGuideProConListContentTypes {
  Description = 0,
  Pro = 1,
  Con = 2,
}

export default BuyingGuideProConListContentTypes;
